import { render, staticRenderFns } from "./RingEchart.vue?vue&type=template&id=0b4a634c&scoped=true&"
import script from "./RingEchart.vue?vue&type=script&lang=js&"
export * from "./RingEchart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4a634c",
  null
  
)

export default component.exports